import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
/**
 * `?memory=team|notes|sops` opens the Memory panel on that tab (the bell's
 * link to a team note, the chat's "Saved to memory" line), then drops the
 * param so a refresh does not reopen it.
 */ export function useMemoryDeepLink(open, enabled = true) {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(()=>{
        if (!enabled) return;
        const params = new URLSearchParams(location.search);
        const want = params.get('memory');
        if (want !== 'team' && want !== 'notes' && want !== 'sops') return;
        open(want);
        params.delete('memory');
        const search = params.toString();
        navigate({
            pathname: location.pathname,
            search: search ? `?${search}` : ''
        }, {
            replace: true
        });
    }, [
        enabled,
        location.pathname,
        location.search,
        navigate,
        open
    ]);
}
